import b from 'b_';
import { DocumentFilled } from 'education-icons';
import { Button, Link, Text } from 'platform-components';
import React from 'react';

import { VIEW } from '../constants';

import './course-container-banner__buttons.scss';

type LinkProps = React.ComponentProps<typeof Link>;

export interface Props {
    mainLink: LinkProps['to'];
    onMainClick?: LinkProps['onClick'];
    onSecondaryClick?: LinkProps['onClick'];
    secondaryLink: LinkProps['to'];
    view: VIEW;
}

export const CourseContainerBannerButtons = (props: Props) => {
    const { mainLink, secondaryLink, onMainClick, onSecondaryClick, view } = props;

    return (
        <div className="course-container-banner__buttons">
            <Link
                className={b('course-container-banner', 'button', { main: true })}
                isRouter
                onClick={onMainClick}
                to={mainLink}
            >
                <Button size={Button.SIZE.L} view={Button.VIEW.ACTION}>
                    <Text id={`courseModuleBanner.button.main.${view}`} size={Text.SIZE.L} weight={Text.WEIGHT.M} />
                </Button>
            </Link>
            <Link
                className={b('course-container-banner', 'button', { secondary: true })}
                isRouter={view !== VIEW.DEFAULT}
                onClick={onSecondaryClick}
                target={view === VIEW.DEFAULT ? '_blank' : undefined}
                to={secondaryLink}
            >
                <Button
                    icon={view === VIEW.DEFAULT ? <DocumentFilled /> : undefined}
                    size={Button.SIZE.L}
                    transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                    view={Button.VIEW.SECONDARY}
                >
                    <Text
                        id={`courseModuleBanner.button.secondary.${view}`}
                        size={Text.SIZE.L}
                        weight={Text.WEIGHT.M}
                    />
                </Button>
            </Link>
        </div>
    );
};
